/* eslint-disable react/no-unknown-property */

/** @jsxRuntime classic */
/* @jsx node */

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { node, Fragment } from 'jsx-pragmatic';

const defaultEnableAnimation = true;

// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ width, height, circle }: any) {
  let style = '';

  if (width) style = style.concat(`width: ${width};`);
  if (height) style = style.concat(`height: ${height};`);
  if (circle) style = style.concat(`border-radius: 50%;`);

  return style;
}

export const SkeletonStyles = () => (
  <style>{`@keyframes react-loading-skeleton {
    100% {
        transform: translateX(100%);
    }
}

body { margin: 0; }

.react-loading-skeleton {
    --base-color: #ebebeb;
    --highlight-color: #f5f5f5;
    --animation-duration: 1.5s;
    --animation-direction: normal;
    --pseudo-element-display: block; /* Enable animation */

    background-color: var(--base-color);

    width: 100%;
    border-radius: 0.25rem;
    display: inline-flex;
    line-height: 1;

    position: relative;
    overflow: hidden;
    z-index: 1; /* Necessary for overflow: hidden to work correctly in Safari */
}

.react-loading-skeleton::after {
    content: ' ';
    display: var(--pseudo-element-display);
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(
        90deg,
        var(--base-color),
        var(--highlight-color),
        var(--base-color)
    );
    transform: translateX(-100%);

    animation-name: react-loading-skeleton;
    animation-direction: var(--animation-direction);
    animation-duration: var(--animation-duration);
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
}`}</style>
);

export function Skeleton({
  count = 1,
  wrapper: Wrapper,
  className: customClassName,
  containerClassName,
  containerTestId,
  circle = false,
  style: styleProp,
  ...propsStyleOptions
}: any) {
  // Props take priority over context
  const styleOptions = {
    ...propsStyleOptions,
    circle,
  };

  // `styleProp` has the least priority out of everything
  const style = styleOptionsToCssProperties(styleOptions);

  let className = 'react-loading-skeleton';
  if (customClassName) className += ` ${customClassName}`;

  const elements = [];

  const finalStyle = style.concat(styleProp);

  for (let i = 0; i < count; i++) {
    const skeletonSpan = (
      <span class={className} style={finalStyle} key={i}>
        &zwnj;
      </span>
    );

    elements.push(
      <Fragment key={i}>
        {skeletonSpan}
        <br />
      </Fragment>,
    );
  }
  return (
    <span
      className={containerClassName}
      data-testid={containerTestId}
      aria-live="polite"
      aria-busy={styleOptions.enableAnimation ?? defaultEnableAnimation}
    >
      {Wrapper ? elements.map((el, i) => <Wrapper key={i}>{el}</Wrapper>) : elements}
    </span>
  );
}
